import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useMutationCourseUpdate } from 'gql/mutations/course';
import { trackEvent, reportError } from 'lib/tracking';

import CourseMethod from './CourseMethod';

const CourseMethodContainer = ({ course, handleIAModalOpen, ...props }) => {
  const { t } = useTranslation();
  const mutationCourseUpdate = useMutationCourseUpdate();
  const handleMethodUpdate = useCallback(
    async (type) => {
      try {
        const d = new Date();
        await mutationCourseUpdate(course, {
          isLinear: type === 'linear',
          isExam: type === 'exam',
          examStartTime: type === 'exam' ? d : null,
          examStopTime: type === 'exam' ? d : null,
        });
        handleIAModalOpen();
        trackEvent('course', 'update');
      } catch (err) {
        reportError('course', 'update', err);
      }
    },
    [course, handleIAModalOpen, mutationCourseUpdate],
  );
  const isModalOpen = course.isLinear === null;
  return (
    isModalOpen && (
      <CourseMethod handleMethodUpdate={handleMethodUpdate} t={t} {...props} />
    )
  );
};

CourseMethodContainer.propTypes = {
  course: PropTypes.object.isRequired,
  handleIAModalOpen: PropTypes.func.isRequired,
};

export default CourseMethodContainer;
